/******************************************************************************

Copyright (c) 2020-2021, Visual Elements

******************************************************************************/

// @format

/** Pagination
 *
 */

import { cr, ap, on } from './../core/highed.dom';
import Events from './../core/highed.events';

export default function(parent) {
  const evervizPaginationContainer = parent,
        evervizPaginationBackButton = cr('button', "everviz-button circle back red", "<i class='fa fa-chevron-left'/>"),
        evervizPaginationNextButton = cr('button', "everviz-button circle red", "<i class='fa fa-chevron-right'/>"),
        events = Events();

  let pageSize = 15,
      page = 1,
      pageCount = false;

  function attachEvents(){
    
    on(evervizPaginationBackButton, 'click', () => {
      if (page - 1 <= 0) return;
      page = page - 1
      getProjects(page, evervizFilterInput.value);
    });

    on(evervizPaginationNextButton, 'click', () => {
      if (page + 1 > pageCount) return;
      page = page + 1;
      getProjects(page, evervizFilterInput.value);
    });
  }

  function setPage(p) {
    page = p;
  }

  function getPage() {
    return page;
  }

  function onSelectPage(index) {
    page = index;
    events.emit('ChangePage', index);
  }
  

  function createLink(text, index, active, disabled){
    let activeClass = active ? ' active' : '';
    let disabledClass = disabled ? ' disabled' : '';

    let onClick = (e) => {
      e.preventDefault();
      if (!active && !disabled) {
        if (text === '«') {
          onSelectPage(1); // First
        } else if (text === '›') {
          onSelectPage(page + 1); // Next
        } else if (text === '‹') {
          onSelectPage(page - 1); // Previous
        } else if (text === '»') {
          onSelectPage(pageCount); // Last
        } else if (index !== page) {
          onSelectPage(index); // 1, 2, 3...
        }
      }
    };

    const li = cr('li', 'page-item' + activeClass + disabledClass);
    const a = cr('a', "page-link", text);
    a.href='#';
    a.tabIndex= (disabled ? '-1' : '');
    on(a, 'click', onClick);
    ap(li, a);
    return li;
  };

  function createPagination(){

    let paginationLinks = [];
    let i = 0;
    paginationLinks.push(createLink('«', i, false, page === 1));
    // Previous
    paginationLinks.push(createLink('‹', i, false, page === 1));

    if (pageCount <= 5){
      // 1, 2, 3...
      for (i = 1; i <= pageCount + 1; i++) {
        paginationLinks.push(createLink(i, i, page === i , null));
      }
    } else {
      let pages = [];

      if (page === 2) pages = [page - 1, page, page + 1, page + 2, page + 3];
      else if (page === 1) pages = [page, page + 1, page + 2, page + 3, page + 4];
      else if ((page) >= pageCount) pages = [page - 4, page - 3, page - 2, page - 1, page];
      else if ((page + 1) >= pageCount) pages = [page - 4, page - 3, page - 2, page, page + 1];
      else pages = [page - 2, page - 1, page, parseInt(page) + 1, parseInt(page) + 2];
      
      pages.forEach((p) => {
        paginationLinks.push(createLink(p, p, (p === page ? true : false)));
      });
    }
    // Next	
    paginationLinks.push(createLink('›', (page <= 2 ? page + 5 : page + 3), false, page === pageCount));
    paginationLinks.push(createLink('»', (page <= 2 ? page + 6 : page + 4), false, page === pageCount));

    const nav = cr('nav');
    nav.setAttribute('aria-label', '...');
    const ul = cr('ul',"everviz-pagination");
    ap(ul, ...paginationLinks);
    ap(nav, ul);
    ap(evervizPaginationContainer, nav);

  }

  function rebuild(count) {
    pageCount = count;
    evervizPaginationContainer.innerHTML = '';

    if (pageCount === 0) return;
    createPagination();
    //ap(evervizPaginationContainer, evervizPaginationBackButton, evervizPaginationNextButton);


  }

  ///////////////////////////////////////////////////////////////////////////

  return {
    //editor: editor,
    on: events.on,
    rebuild: rebuild,
    setPage: setPage,
    getPage: getPage
  };
};
